import type { JobAd } from "@/modules/jobAds/client/api/types"
import type { FunctionComponent } from "react"

import { JobAdWrapper } from "@/modules/jobAds/client/components/JobAdWrapper/JobAdWrapper"

import styles from "./Results.module.css"

export type JobAdsResultProps = {
  jobAds: JobAd[]
}

export const Results: FunctionComponent<JobAdsResultProps> = ({ jobAds }) => {
  return (
    <ul className={styles.main} data-testid="job-ads-wrapper">
      {jobAds.map(jobAd => (
        <JobAdWrapper key={jobAd.id} jobAd={jobAd} />
      ))}
    </ul>
  )
}
